export default function CtaSection() {
  return (
    <section className="bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[500px] md:min-h-[600px]">
        <div className="relative overflow-hidden rounded-2xl lg:rounded-none lg:rounded-l-2xl m-4 lg:m-0 lg:ml-4 lg:my-4">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20home%20office%20workspace%20with%20an%20open%20laptop%20displaying%20organized%20spreadsheet%20on%20screen%20warm%20afternoon%20sunlight%20streaming%20through%20sheer%20curtains%20light%20oak%20desk%20with%20a%20small%20potted%20plant%20and%20notebook%20clean%20minimal%20aesthetic%20warm%20neutral%20cream%20tones%20calm%20productive%20atmosphere%20editorial%20interior%20photography&width=800&height=900&seq=cta-left-v3-001&orientation=portrait"
            alt="Modern productive workspace"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10">
            <span className="text-white/70 text-xs font-medium tracking-wide uppercase mb-3 block">
              Start Today
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight">
              Get
              <br />
              Mulebuy
              <br />
              Spreadsheet
            </h2>
          </div>
        </div>

        <div className="flex items-center justify-center p-8 md:p-12 lg:p-16 bg-background-50">
          <div className="text-center max-w-md">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              Ready to Start
              <br />
              Smart Sourcing?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              Get access to structured guides, tools, and comparison systems. Start using a smarter mulebuy spreadsheet system today and transform how you track and buy products.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 bg-foreground-950 text-white rounded-full font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap flex items-center gap-2"
              >
                <span>Buy It Now</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 border border-foreground-300 text-foreground-800 rounded-full font-medium text-sm hover:border-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                Mulebuy Spreadsheet
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}